export const Organizations = {
  SMM: 'SMM',
  ATRUVIA: 'ATRUVIA',
  FINO: 'FINO',
};
